var map = {
	"./agro.svg": 828,
	"./bank.svg": 945,
	"./basket.svg": 83,
	"./building.svg": 584,
	"./ceo.svg": 310,
	"./chemistry.svg": 475,
	"./horlogy.svg": 768,
	"./industry.svg": 435,
	"./invest.svg": 738,
	"./luxury.svg": 922,
	"./misc.svg": 829,
	"./podium.svg": 638,
	"./services.svg": 76,
	"./shipping.svg": 841,
	"./stadium.svg": 28,
	"./technology.svg": 151
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 229;